import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react";

import { Link } from "@chakra-ui/next-js";
import heroBg from "@root/public/images/home-hero.jpg";
import { useTranslations } from "next-intl";
import Navbar from "./Navbar";
import { LetsClarifayoLink } from "./LetsClarifayoLink";

export const HomeHero = () => {
  const t = useTranslations();

  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      py={{ base: 8, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      justifyContent={"flex-end"}
      bgColor="brand.1000"
      h="full"
      minH={{
        base: "90vh",
        md: "90vh",
      }}
      position="relative"
      overflow={"hidden"}
      backgroundImage={`url(${heroBg.src})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundAttachment="fixed"
    >
      <Box className="hero-bg"></Box>
      {/*  <Box className="hero-bg">
        {isMobile ? (
          <Image
            src={heroBg}
            alt="hero background"
            width={4352/4}
            height={2901/4}
            quality={80}
            objectFit="cover"
            loading="eager"
            style={{
              position: "absolute",
              objectFit: "cover",
              left: 0,
              top: 0,
              height: "100%",
              zIndex: 0,
            }}
          />
        ) : (
          <Image
            src={heroBg}
            alt="hero background"
            width={4352/4}
            height={2901/4}
            quality={80}
            objectFit="cover"
            loading="eager"
            style={{
              position: "absolute",
              aspectRatio: "16/9",
              left: 0,
              top: "-10vh",
              maxWidth: "140vw",
              width: "140vw",
              height: "140vh",
              objectFit: "cover",
              zIndex: 0,
            }}
          />
        )}
      </Box> */}
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>

      <Stack
        direction={["column", "row"]}
        gap={16}
        alignItems={"flex-end"}
        w="full"
        zIndex={1}
      >
        <Box flex={1} maxW={{ base: "full", md: "50vw" }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: "42px", md: "68px" }}
            mb={4}
            textAlign={{ base: "center", md: "left" }}
            color="white"
            lineHeight={"1.1"}
            letterSpacing={".1rem"}
            fontFamily={`'Marlide', sans-serif`}
          >
            <Text>{t("landingPage.title.part1")}</Text>
            <Text
              dangerouslySetInnerHTML={{
                __html: t.raw("landingPage.title.part2"),
              }}
            ></Text>
            <Text>{t("landingPage.title.part3")}</Text>
          </Heading>
          <Text
            fontSize={{ base: "18px", md: "22px" }}
            color="white"
            textAlign={{ base: "center", md: "left" }}
            maxW={{ base: "full", md: "500px" }}
            mb={8}
          >
            {t("landingPage.subtitle")}
          </Text>
        </Box>
      </Stack>

      <Stack
        direction={["column", "row"]}
        alignSelf={"flex-start"}
        position={"relative"}
        alignItems="center"
        gap={8}
        w="full"
      >
        <LetsClarifayoLink />
      </Stack>
    </Stack>
  );
};
